import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { EmployeeGrade, ProfileInfoCard } from "@components";

import { useBaseData } from "@hooks/useBaseData";

import { BASE_DATA } from "@constants/base-data";

import { EmployeeType } from "@type/HRM/employees";

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  const { data: grades } = useBaseData(BASE_DATA.GRADES);

  return [
    {
      id: 1,
      key: "nameBn",
      name: t("EMPLOYEES.TABLE.COLUMN.NAME"),
      render: (nameBn: string, row: EmployeeType) => (
        <ProfileInfoCard employee={row as any} />
      ),
    },
    {
      id: 2,
      key: "gradeId",
      name: t("SENIORITY_LIST.TABLE_COLUMN.EMPLOYEE_GRADE"),
      render: (gradeId: number) => (
        <EmployeeGrade grades={grades} gradeId={gradeId} />
      ),
    },
    {
      id: 3,
      key: "joiningDate",
      name: t("SENIORITY_LIST.TABLE_COLUMN.JOINING_DATE"),
      render: (joiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {joiningDate}
        </Text>
      ),
    },
    {
      id: 4,
      key: "dateOfBirth",
      name: t("SENIORITY_LIST.TABLE_COLUMN.DATE_OF_BIRTH"),
      render: (disciplinaryAction: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {disciplinaryAction}
        </Text>
      ),
    },
    {
      id: 5,
      key: "lastPromotionDate",
      name: t("SENIORITY_LIST.TABLE_COLUMN.LAST_PROMOTION_DATE"),
      render: (lastPromotionDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {lastPromotionDate}
        </Text>
      ),
    },
  ];
};
